import React from 'react';
import { NavLink } from 'react-router-dom';

const Tab = ({ name, link, classes = ""}) => {
    const className = isActive => {
        let ret = `tab ${classes}`;
        if (isActive) {
            ret += ' active';
        }
        return ret;
    };

    const style = {
        top: '1px',
    };

    const activeStyle = {
        background: 'linear-gradient(180deg, #2EAFFF 0%, #2CA9FF 100%)',
    };

    return (
        <NavLink className={className} to={link}>
            {name}
        </NavLink>
    );
}

export default Tab;